import { resolveAssistantErrorDisplay } from '../../timeline/components/assistantErrorDisplay.js';

export function conditionalValue(condition, whenTrue, whenFalse = null) {
  return condition ? whenTrue : whenFalse;
}

export function firstTruthy(...values) {
  return values.find(Boolean);
}
export function normalizeComposerProps({ sendDisabled = false, activeTargetChip = null, ...props }) { return { ...props, sendDisabled, activeTargetChip }; }
export function hasIntentEscalationConfig(intentEscalationPolicyPopoverContent, intentEscalationConfigEntryLabel) {
  return Boolean(intentEscalationPolicyPopoverContent && intentEscalationConfigEntryLabel);
}
export function objectOrNull(value) { return typeof value === 'object' ? value : null; }

export function resolveSendOutcomeFeedback(value) {
  const outcome = objectOrNull(value);
  const status = String(outcome?.status || '').trim();
  if (['', 'completed'].includes(status)) {
    return null;
  }
  const error = Object.assign({}, outcome?.error);
  const message = resolveAssistantErrorDisplay({
    ...error, message: firstTruthy(outcome?.reason, error.message, status),
    recovery: error.recovery ?? { action: 'none' },
  }).userMessage;
  return {
    message,
    type: status === 'blocked' ? 'warning' : 'error',
  };
}

export function resolveComposerSectionState({
  modeSuggestion,
  modeSuggestionAction,
  effectiveComposerChooser,
  statusOnlyTipHidden,
  shouldRenderModeSuggestion,
  modeSuggestionFromFallback,
  streamLoading,
  sendSubmitting,
  recommendationPanelState,
  canonicalActionEntries,
  latestUnreadCue,
  intentEscalationPolicyPopoverContent,
  intentEscalationConfigEntryLabel,
  contextActivityState,
  contextActivityStatus,
  contextGaugeHeadline,
}) {
  const latestCue = Object.assign({}, latestUnreadCue);
  const composerBusy = [streamLoading, sendSubmitting].some(Boolean);
  return {
    composerBusy,
    contextGaugeShortLabel: String(contextGaugeHeadline || '').trim(),
    contextGaugeState: String(contextActivityState || '').trim(),
    contextGaugeStatus: String(contextActivityStatus || '').trim(),
    latestCue,
    resolvedModeSuggestion: modeSuggestion ?? null,
    resolvedModeSuggestionAction: objectOrNull(modeSuggestionAction),
    shouldShowCanonicalActions: [
      !composerBusy,
      !effectiveComposerChooser,
      Array.isArray(canonicalActionEntries),
      canonicalActionEntries.length > 0,
    ].every(Boolean),
    shouldShowIntentEscalationConfigEntry: hasIntentEscalationConfig(
      intentEscalationPolicyPopoverContent,
      intentEscalationConfigEntryLabel,
    ),
    shouldShowLatestUnreadCue: [
      Boolean(latestUnreadCue),
      latestCue.visible,
      typeof latestCue.onReadLatest === 'function',
    ].every(Boolean),
    shouldShowModeSuggestion: [
      !effectiveComposerChooser,
      !statusOnlyTipHidden,
      [shouldRenderModeSuggestion, modeSuggestionFromFallback].some(Boolean),
    ].every(Boolean),
    suggestionAllowedByPanelState: [
      recommendationPanelState === 'hidden',
      recommendationPanelState === 'hidden_typing',
      modeSuggestionFromFallback,
    ].some(Boolean),
  };
}
